import { GET_ALL_MARKUPS_REQUEST, GET_ALL_MARKUPS_SUCCESS } from '../actionConstants/markupConstants';

export const getAllMarkupsRequest = () => ({ type: GET_ALL_MARKUPS_REQUEST });
export const getAllMarkupsSuccess = ({ markups }) => ({
  type: GET_ALL_MARKUPS_SUCCESS,
  payload: { markups },
});
